import React, { useState } from 'react';
import { useNavigate } from 'react-router';
import { Box, Menu, MenuItem, ListItemIcon, ListItemText } from '@mui/material';
import {
  KeyboardArrowDown as KeyboardArrowDownIcon,
  Logout as LogoutIcon,
} from '@mui/icons-material';
import { styled } from '@mui/material/styles';

import { paths } from '@/config/paths';
import { useAuth } from '@/hooks/use-auth';

const ProfileSectionContainer = styled(Box)(({ theme }) => ({
  display: 'flex',
  alignItems: 'center',
  gap: theme.spacing(1),
  [theme.breakpoints.down('sm')]: {
    gap: theme.spacing(0.5),
  },
}));

const ProfileButton = styled(Box)(({ theme }) => ({
  display: 'flex',
  alignItems: 'center',
  gap: theme.spacing(1),
  padding: theme.spacing(1, 1.5),
  borderRadius: theme.spacing(3),
  border: '1px solid #FFFFFF',
  backgroundColor: 'transparent',
  cursor: 'pointer',
  transition: 'all 0.2s ease-in-out',
  '&:hover': {
    backgroundColor: 'rgba(255, 255, 255, 0.1)',
  },
  [theme.breakpoints.down('sm')]: {
    padding: theme.spacing(0.5, 1),
  },
}));

const UserInfo = styled(Box)(() => ({
  display: 'flex',
  flexDirection: 'column',
  alignItems: 'center',
}));

const UserName = styled('div')(() => ({
  color: '#FFFFFF',
  fontWeight: 500,
  fontSize: '0.9rem',
  lineHeight: 1.2,
}));

export const ProfileSection = () => {
  const [anchorEl, setAnchorEl] = useState<null | HTMLElement>(null);
  const navigate = useNavigate();
  const open = Boolean(anchorEl);
  const { user } = useAuth();

  const handleProfileClick = (event: React.MouseEvent<HTMLElement>) => {
    setAnchorEl(event.currentTarget);
  };

  const handleClose = () => {
    setAnchorEl(null);
  };

  const handleLogout = () => {
    // Clear OIDC session
    // clearAuthSession();

    // Close menu
    handleClose();

    // Redirect to home page - it will check session and redirect to login
    navigate(paths.auth.logout.path);
  };

  return (
    <ProfileSectionContainer>
      {/* Profile Button with Border */}
      <ProfileButton onClick={handleProfileClick}>
        {/* User Info */}
        <UserInfo>
          <UserName>
            {user?.lastName} {user?.firstName}
          </UserName>
        </UserInfo>

        {/* Profile Dropdown Icon */}
        <KeyboardArrowDownIcon
          sx={{
            color: '#FFFFFF',
            fontSize: '1.2rem',
          }}
        />
      </ProfileButton>

      <Menu
        id='profile-menu'
        anchorEl={anchorEl}
        open={open}
        onClose={handleClose}
        slotProps={{
          paper: {
            elevation: 0,
            sx: {
              overflow: 'visible',
              filter: 'drop-shadow(0px 2px 8px rgba(0,0,0,0.32))',
              mt: 1.5,
              '& .MuiAvatar-root': {
                width: 32,
                height: 32,
                ml: -0.5,
                mr: 1,
              },
              '&:before': {
                content: '""',
                display: 'block',
                position: 'absolute',
                top: 0,
                right: 14,
                width: 10,
                height: 10,
                bgcolor: 'background.paper',
                transform: 'translateY(-50%) rotate(45deg)',
                zIndex: 0,
              },
            },
          },
        }}
        transformOrigin={{ horizontal: 'right', vertical: 'top' }}
        anchorOrigin={{ horizontal: 'right', vertical: 'bottom' }}
      >
        <MenuItem onClick={handleLogout}>
          <ListItemIcon>
            <LogoutIcon fontSize='small' />
          </ListItemIcon>
          <ListItemText>ログアウト</ListItemText>
        </MenuItem>
      </Menu>
    </ProfileSectionContainer>
  );
};
